import { render, staticRenderFns } from "./ResumeUnityCard.vue?vue&type=template&id=3bc3c649&"
import script from "./ResumeUnityCard.vue?vue&type=script&lang=js&"
export * from "./ResumeUnityCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports